import { useFeaturedCards } from 'src/react_query'
import {
  Grid,
  GridItem,
  Image,
  LoadingSpinner,
} from '@sendoutcards/quantum-design-ui'

const FeaturedCardsGrid = () => {
  const { data: featuredCardsData, isLoading } = useFeaturedCards()
  const featuredCards = featuredCardsData?.featuredCards ?? []

  if (isLoading) {
    return <LoadingSpinner size="large" />
  }

  return (
    <Grid height="100%" columnSize={49} rowSize={35} gap={12}>
      {[...featuredCards, ...featuredCards, ...featuredCards].map(
        (card, index) => (
          <GridItem
            gridColSpan={2}
            gridRowSpan={card.isHorizontal ? 2 : 4}
            borderRadius="medium"
            key={index}
          >
            <Image
              image={{ url: card.frontImage.smallThumb }}
              width="100%"
              height="100%"
              isActive={true}
              borderRadius="none"
            />
          </GridItem>
        ),
      )}
    </Grid>
  )
}

export default FeaturedCardsGrid
